import config from "../../config";
import dayjs from 'dayjs';
import { useDispatch, useSelector } from "react-redux";
import { Image, Loader, Grid, Card,Group, Text } from '@mantine/core';
import { Trash, FileDownload } from 'tabler-icons-react';
import intl from "react-intl-universal";



const ModalMakeScreen = (props:any) => {  
    const dispatch = useDispatch()
    const screenshots = useSelector((state: any) => state.user.identscreenshots)
    const meetinguser = useSelector((state: any) => state.user.meetinguser)
    const token = useSelector((state: any) => state.user.token)
    const meetingtitle = useSelector((state: any) => state.user.meetinginfo.title)
  

   // Check id User is online
 let meetinguserselectet
   meetinguserselectet = meetinguser.filter((obj: { id: any }) => {
    return obj.id === props.meetingParticipantId 
 
});

const fetchPdf = async (Id:any) => {

  let fetchurl
  try {
  if (config.downloadUrlSnapShot !== undefined) {
      fetchurl = config.downloadUrlSnapShot
   } else {
  fetchurl = "https://notarcms-hub.dev.lilenium.com/api/Snapshot/signSnapShotAndGetPdf?id="
  throw new Error ("WS: Keine Docker Umgebunsvariablen gefunden!");
  }
  } catch (e) {
  console.log("WS: Nutze Lokale Testdaten");
   } finally {}

   let now = dayjs(new Date());
  let imageid= Id
  let urltoken = "&token="+token
  let apicall = fetchurl+imageid+urltoken

  try {
    const response = await fetch(apicall);
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const pdfBlob = await response.blob();
    const newFilename = meetingtitle+"_"+imageid+"_"+now.format('DD:MM:YYYY HH:mm:ss')+".pdf";
    
    const link = document.createElement('a');
    link.href = URL.createObjectURL(pdfBlob);
    link.download = newFilename;
    link.click();
  } catch (error) {
    console.error('Error fetching and opening PDF:', error);
  }
};

const paratoken = "&token="+token


const meetinguserstatus = meetinguserselectet[0].meetingParticipantStatus

    const deletscreenshot = (Id:any) => {
        const deletescreenshotpayload ={
            Id: Id,
        }  
        //console.log(deletescreenshotpayload)
        dispatch({ type: 'SIGNALR_DELETE_SCREENSHOT', payload: deletescreenshotpayload  });

    }


    // Filter auf particiapnt id bei mehrerer Teilnehmer im Meeting
    let screendata:any
    screendata = screenshots.filter((obj: { userParticipantId: any }) => {
          return obj.userParticipantId === props.meetingParticipantId 
       
    });

    // Wenn es nur einen Screenshot gibt große Darstellung
    let bigimage
    let  lastScreenimage
    let  lastScreenID:any
    let olderimage

    
    if (screendata.length === 1){
        bigimage = screendata[0].imageSrc+paratoken;
    }
    
    
    if (screendata.length >= 2){
        const lastScreen = screendata[screendata.length - 1];
        lastScreenimage = lastScreen.imageSrc;
        lastScreenID = lastScreen.id

        const beforeScreens = screendata.slice(0, -1);

        olderimage = beforeScreens.map((olderimage:any) => ( 
          <>
          <Grid.Col span={3}>
          <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Card.Section>
                <Image  src={olderimage.imageSrc+paratoken} />
            </Card.Section>
            <Group position="apart" mt="md" mb="xs">
                <Text weight={500}>{intl.get('LASTSCREENTAKEN_TT_DELETE')} </Text>
                <Trash size={28} strokeWidth={1} color="red"  onClick={() => deletscreenshot(olderimage.id)}/>
                <FileDownload  size={28} strokeWidth={1} color="green"  onClick={() => fetchPdf(olderimage.id)}/>
                
            </Group>
            </Card>
          </Grid.Col>
          </>
        ));
    }

 
  return ( 
    <>
     
      {screendata.length === 1 &&
         <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Card.Section>
               <Image  src={bigimage} />
            </Card.Section>
            <Group position="right" mt="md" mb="xs">
                {meetinguserstatus !== "InMeeting" &&
                <Text weight={500}>{intl.get('MODALMAKESCREEN_NOUSER')}</Text>
                }   
                {meetinguserstatus === "InMeeting" &&
                <>
                <Text weight={500}>{intl.get('LASTSCREENTAKEN_TT_DELETE')}</Text>
                </>
                } 
                <Trash size={48} strokeWidth={1} color="red" onClick={() => deletscreenshot(screendata[0].id)}/>
                <FileDownload  size={28} strokeWidth={1} color="green"  onClick={() => fetchPdf(screendata[0].id)}/>
            </Group>
        </Card>
      } 
      {screendata.length >= 2 &&
      <>
       <Grid>
        {olderimage}
      </Grid>
        <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Card.Section>
            <Image src={lastScreenimage+paratoken} />
        </Card.Section>
        <Group position="right" mt="md" mb="xs">
                {meetinguserstatus !== "InMeeting" &&
                <Text weight={500}>{intl.get('MODALMAKESCREEN_NOUSER')}</Text>
                } 
                {meetinguserstatus === "InMeeting" &&
                <>
                <Text weight={500}>{intl.get('LASTSCREENTAKEN_TT_DELETE')}</Text>
                </>
                } 
                <Trash size={48} strokeWidth={1} color="red"  onClick={() => deletscreenshot(lastScreenID)} />
                <FileDownload  size={28} strokeWidth={1} color="green"  onClick={() => fetchPdf(lastScreenID)}/>
            </Group>
        </Card>
       
      </>
      }
    </>
  );
}

export default ModalMakeScreen;